module.exports = isNode

function isNode (val) {
  return (!val || typeof val !== 'object')
    ? false
    : (typeof window === 'object' && typeof window.Node === 'object')
      ? (val instanceof window.Node)
      : (typeof val.nodeType === 'number') &&
        (typeof val.nodeName === 'string')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-dom/index.js
// module id = 169
// module chunks = 0